import axiosInstance from "./AxiosInstance";
import config from "../config";

const { apiAppendPath } = config;

export const getDiagnoses = (searchString) => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/diagnoses`, {
        params: { searchString },
        cache: false,
    });
}

export const createCompound = (data) => {
    return axiosInstance.post(`${apiAppendPath.prescriptionsAppendPath}/compounds`, data);
}

export const getCompounds = () => {
    return axiosInstance.get(`${apiAppendPath.prescriptionsAppendPath}/compounds`);
}

export const updateCompound = (compoundId, data) => {
    return axiosInstance.put(`${apiAppendPath.prescriptionsAppendPath}/compounds/${compoundId}`, data);
}

export const deleteCompound = (compoundId) => {
    return axiosInstance.delete(`${apiAppendPath.prescriptionsAppendPath}/compounds/${compoundId}`);
}
